/**
 * In-memory CSRF token shared between the axios client and code that cannot
 * use it (e.g. the synchronous `beforeunload` hangup).
 *
 * The backend sets the `_csrf` cookie host-only on api.<domain>, so the SPA on
 * app.<domain> can NOT read it from `document.cookie` in production; the token
 * returned by GET /api/csrf-token is the only reliable copy.
 */
let token: string | null = null

export function getCsrfToken(): string | null {
  return token
}

export function setCsrfToken(next: string | null): void {
  token = next
}
